/**
 * Gender + Color tag filters use the same Shopify param (filter.p.tag),
 * which ORs values. To get AND across groups we keep gender on the
 * collection URL path and color (and other tags) in filter.p.tag.
 */
(function () {
  if (window.__fcloCollectionTagAndInit) return;
  window.__fcloCollectionTagAndInit = true;

  var GENDER_FALLBACK = ['boys', 'girls'];
  var COLOR_FAMILY_FALLBACK = ['yellow', 'orange', 'red', 'pink', 'purple', 'blue', 'green', 'brown'];
  var NEUTRAL_FALLBACK = ['black', 'beige', 'white', 'grey'];

  function getConfigRoot() {
    return (
      document.querySelector('[data-collection-url]') ||
      document.querySelector('[data-color-filter]') ||
      document.querySelector('[data-tag-filter-group="gender"]')
    );
  }

  function getCollectionBase() {
    var root = document.querySelector('[data-collection-url]');
    if (!root) return '';
    return (root.getAttribute('data-collection-url') || '').replace(/\/$/, '');
  }

  function csvAttr(el, name, fallback) {
    var raw = (el && el.getAttribute(name)) || fallback.join(',');
    return raw
      .split(',')
      .map(function (tag) {
        return tag.toLowerCase().trim();
      })
      .filter(Boolean);
  }

  function getGenderTags() {
    var el =
      document.querySelector('[data-gender-tags]') ||
      document.querySelector('[data-tag-filter-group="gender"]') ||
      getConfigRoot();
    return csvAttr(el, 'data-gender-tags', GENDER_FALLBACK);
  }

  function getColorRoot() {
    return document.querySelector('[data-color-filter]');
  }

  function getFamilyTags(root) {
    return csvAttr(root || getColorRoot(), 'data-color-family-tags', COLOR_FAMILY_FALLBACK);
  }

  function getNeutralTags(root) {
    return csvAttr(root || getColorRoot(), 'data-neutral-sub-tags', NEUTRAL_FALLBACK);
  }

  function getAllManagedColorTags(root) {
    return getFamilyTags(root).concat(getNeutralTags(root));
  }

  function isGenderTag(tag) {
    return getGenderTags().indexOf(String(tag).toLowerCase()) !== -1;
  }

  function isColorTag(tag) {
    return getAllManagedColorTags(getColorRoot()).indexOf(String(tag).toLowerCase()) !== -1;
  }

  function uniqueTags(tags) {
    var seen = {};
    var out = [];
    tags.forEach(function (tag) {
      var key = String(tag).toLowerCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(tag);
    });
    return out;
  }

  function extractPathTags(pathname, basePath) {
    if (!basePath) return [];
    if (pathname === basePath || pathname === basePath + '/') return [];
    if (pathname.indexOf(basePath + '/') !== 0) return [];
    var segment = pathname.slice(basePath.length + 1).split('/')[0];
    if (!segment) return [];
    return segment
      .split('+')
      .map(function (tag) {
        try {
          return decodeURIComponent(tag).toLowerCase().trim();
        } catch (e) {
          return tag.toLowerCase().trim();
        }
      })
      .filter(Boolean);
  }

  function stripColorTags(params, root) {
    var managed = getAllManagedColorTags(root);
    var kept = params.getAll('filter.p.tag').filter(function (tag) {
      return managed.indexOf(tag.toLowerCase()) === -1;
    });
    params.delete('filter.p.tag');
    kept.forEach(function (tag) {
      params.append('filter.p.tag', tag);
    });
  }

  function stripGenderFromParams(params) {
    var kept = params.getAll('filter.p.tag').filter(function (tag) {
      return !isGenderTag(tag);
    });
    params.delete('filter.p.tag');
    kept.forEach(function (tag) {
      params.append('filter.p.tag', tag);
    });
  }

  /**
   * Intent for the in-flight filter update, cleared once history is updated.
   * preserveColors: re-apply URL-only color tags (Neutrals) when another group changes.
   * preserveGender: re-apply the selected gender to theme-generated filter links.
   * Both must be off while removing a filter, otherwise the removed value comes back.
   */
  var navIntent = null;

  function setNavIntent(intent) {
    navIntent = intent;
  }

  function shouldPreserveColors() {
    return !navIntent || navIntent.preserveColors !== false;
  }

  function shouldPreserveGender() {
    return !navIntent || navIntent.preserveGender !== false;
  }

  function readUiGenderParams(params) {
    var raw = params.get('fclo_gender') || '';
    return uniqueTags(
      raw
        .split(',')
        .map(function (tag) {
          return tag.toLowerCase().trim();
        })
        .filter(isGenderTag)
    );
  }

  /**
   * Neutrals / color-family tags are often only in the URL (virtual controls),
   * not in the sidebar form. Keep them when gender/size rebuilds the query.
   */
  function mergePreservedColorTags(urlInput) {
    if (!shouldPreserveColors()) return urlInput;

    var basePath = getCollectionBase();
    var next = new URL(urlInput, window.location.href);
    var prev = new URL(window.location.href);

    var nextColors = next.searchParams.getAll('filter.p.tag').filter(isColorTag);
    if (nextColors.length) return urlInput;

    var prevColors = prev.searchParams.getAll('filter.p.tag').filter(isColorTag);
    if (!prevColors.length) return urlInput;

    // Clear-all: bare collection URL with no filters
    if (basePath) {
      var path = next.pathname.replace(/\/$/, '');
      var hasFilterParam = false;
      next.searchParams.forEach(function (_val, key) {
        if (key.indexOf('filter.') === 0 || key === 'fclo_gender') hasFilterParam = true;
      });
      if (path === basePath && !hasFilterParam) return urlInput;
    }

    prevColors.forEach(function (tag) {
      next.searchParams.append('filter.p.tag', tag);
    });

    var query = next.searchParams.toString();
    return next.pathname + (query ? '?' + query : '');
  }

  /**
   * Rebuild URL for AND across gender + color:
   * - 1 gender → path tag + color in filter.p.tag
   * - 2 genders + color → color only in filter.p.tag; genders kept in fclo_gender (UI)
   * - 2 genders, no color → both genders in filter.p.tag (OR)
   */
  function normalizeAndUrl(urlInput) {
    var basePath = getCollectionBase();
    if (!basePath) return urlInput;

    var url = new URL(urlInput, window.location.href);
    if (!(url.pathname === basePath || url.pathname.indexOf(basePath + '/') === 0)) {
      return typeof urlInput === 'string' ? urlInput : url.pathname + url.search;
    }

    var pathTags = extractPathTags(url.pathname, basePath);
    var queryTags = url.searchParams.getAll('filter.p.tag');
    var uiGenders = readUiGenderParams(url.searchParams);
    var allTags = uniqueTags(pathTags.concat(queryTags));

    var genders = [];
    var others = [];
    allTags.forEach(function (tag) {
      if (isGenderTag(tag)) genders.push(tag.toLowerCase());
      else others.push(tag);
    });
    genders = uniqueTags(genders.concat(uiGenders));
    others = uniqueTags(others);

    var hasColor = others.some(isColorTag);

    url.searchParams.delete('filter.p.tag');
    url.searchParams.delete('fclo_and');
    url.searchParams.delete('fclo_gender');

    if (genders.length === 1) {
      url.pathname = basePath + '/' + genders[0];
      others.forEach(function (tag) {
        url.searchParams.append('filter.p.tag', tag);
      });
    } else if (genders.length > 1 && hasColor) {
      // Both genders selected = no gender restriction; Shopify must filter by color only
      url.pathname = basePath;
      others.forEach(function (tag) {
        url.searchParams.append('filter.p.tag', tag);
      });
      url.searchParams.set('fclo_gender', genders.join(','));
    } else if (genders.length > 1) {
      url.pathname = basePath;
      genders.concat(others).forEach(function (tag) {
        url.searchParams.append('filter.p.tag', tag);
      });
    } else {
      url.pathname = basePath;
      others.forEach(function (tag) {
        url.searchParams.append('filter.p.tag', tag);
      });
    }

    var query = url.searchParams.toString();
    return url.pathname + (query ? '?' + query : '');
  }

  function triggerFilterUrl(url) {
    var normalized = normalizeAndUrl(mergePreservedColorTags(url));
    var sidebar = document.querySelector('[data-collection-sidebar]');
    var link = document.createElement('a');
    link.href = normalized;
    link.setAttribute('data-filter-update-url', '');
    link.setAttribute('data-fclo-final', '');
    link.hidden = true;

    if (sidebar) {
      sidebar.appendChild(link);
      link.click();
      link.remove();
    } else {
      window.location.href = normalized;
    }
  }

  function buildColorUrl(addTags) {
    var root = getColorRoot();
    var url = new URL(window.location.href);
    if (root) stripColorTags(url.searchParams, root);
    stripGenderFromParams(url.searchParams);
    addTags.forEach(function (tag) {
      url.searchParams.append('filter.p.tag', tag);
    });
    var query = url.searchParams.toString();
    // Skip mergePreservedColorTags — colors are intentional (including Rainbow = [])
    return normalizeAndUrl(url.pathname + (query ? '?' + query : ''));
  }

  function readCheckedGenderFromDom() {
    var checked = [];
    document.querySelectorAll('[data-tag-filter-group="gender"] input[type="checkbox"]').forEach(function (input) {
      if (!input.checked || input.disabled) return;
      var tag = (input.getAttribute('data-gender-tag') || input.value || '').toLowerCase().trim();
      if (tag) checked.push(tag);
    });
    return uniqueTags(checked);
  }

  function buildUrlFromFormWithGender(genderTags) {
    var basePath = getCollectionBase() || window.location.pathname.replace(/\/$/, '');
    var form = document.querySelector('[data-sidebar-filter-form]');
    var params = new URLSearchParams();
    var current = new URL(window.location.href);

    if (current.searchParams.get('sort_by')) {
      params.set('sort_by', current.searchParams.get('sort_by'));
    }

    // Keep current color tags (Neutrals are virtual — not in FormData)
    current.searchParams.getAll('filter.p.tag').forEach(function (tag) {
      if (isGenderTag(tag)) return;
      params.append('filter.p.tag', tag);
    });

    // Keep other active filters from the current URL (price, etc.)
    current.searchParams.forEach(function (val, key) {
      if (key === 'filter.p.tag' || key === 'sort_by' || key === 'page') return;
      if (key === 'fclo_gender' || key === 'fclo_and') return;
      if (key.indexOf('filter.') === 0) {
        params.append(key, val);
      }
    });

    if (form) {
      var formParams = new URLSearchParams(new FormData(form));
      var seenKeys = {};

      // Prefer live form values for non-color filters (size, price)
      formParams.forEach(function (val, key) {
        if (!val) return;
        if (key === 'fclo_gender' || key === 'fclo_and') return;
        if (key === 'filter.p.tag') {
          if (isGenderTag(val)) return;
          // Avoid duplicating colors already copied from the URL
          var exists = params.getAll('filter.p.tag').some(function (tag) {
            return tag.toLowerCase() === val.toLowerCase();
          });
          if (!exists) params.append(key, val);
          return;
        }
        if (key.indexOf('filter.') === 0) {
          if (!seenKeys[key]) {
            params.delete(key);
            seenKeys[key] = true;
          }
          params.append(key, val);
        }
      });
    }

    genderTags = uniqueTags(genderTags || []);
    if (genderTags.length === 1) {
      params.append('filter.p.tag', genderTags[0]);
    } else if (genderTags.length > 1) {
      params.set('fclo_gender', genderTags.join(','));
      genderTags.forEach(function (tag) {
        params.append('filter.p.tag', tag);
      });
    }

    var query = params.toString();
    return normalizeAndUrl(basePath + (query ? '?' + query : ''));
  }

  function syncColorVisualState() {
    var root = getColorRoot();
    if (!root) return;

    var familyTags = getFamilyTags(root);
    var neutralTags = getNeutralTags(root);
    var activeTags = new URL(window.location.href).searchParams.getAll('filter.p.tag').map(function (tag) {
      return tag.toLowerCase();
    });

    var familyActive = activeTags.some(function (tag) {
      return familyTags.indexOf(tag) !== -1;
    });
    var neutralActive = activeTags.some(function (tag) {
      return neutralTags.indexOf(tag) !== -1;
    });
    var rainbowActive = !familyActive && !neutralActive;

    root.querySelectorAll('[data-color-option]').forEach(function (row) {
      var option = (row.getAttribute('data-color-option') || '').toLowerCase();
      var input = row.querySelector('input[type="checkbox"]');
      var active = false;

      if (option === 'rainbow') active = rainbowActive;
      else if (option === 'neutral') active = neutralActive;
      else active = activeTags.indexOf(option) !== -1;

      if (input) input.checked = active;
      row.classList.toggle('is-active', active);
    });
  }

  function getActiveGendersFromLocation() {
    var basePath = getCollectionBase();
    var url = new URL(window.location.href);
    var pathGenders = basePath ? extractPathTags(url.pathname, basePath).filter(isGenderTag) : [];
    var queryGenders = url.searchParams.getAll('filter.p.tag').filter(isGenderTag);
    var uiGenders = readUiGenderParams(url.searchParams);
    return uniqueTags(pathGenders.concat(queryGenders).concat(uiGenders));
  }

  function syncGenderVisualState() {
    var active = getActiveGendersFromLocation();
    var group = document.querySelector('[data-tag-filter-group="gender"]');
    var availableCsv = group ? (group.getAttribute('data-available-genders') || '') : '';

    document.querySelectorAll('[data-tag-filter-group="gender"] input[type="checkbox"]').forEach(function (input) {
      var tag = (input.getAttribute('data-gender-tag') || input.value || '').toLowerCase();
      var isActive = active.indexOf(tag) !== -1;
      var attrAvailable = input.getAttribute('data-gender-available');
      var inCollection =
        attrAvailable === 'true' ||
        (attrAvailable !== 'false' && availableCsv.indexOf(tag) !== -1);
      var isUnavailable = !isActive && !inCollection;

      input.checked = isActive;
      input.disabled = isUnavailable;

      var row = input.closest('[data-option-holder]');
      if (row) {
        row.classList.toggle('is-active', isActive);
        row.classList.toggle('is-unavailable', isUnavailable);
      }
    });
  }

  function capitalizeLabel(tag) {
    if (!tag) return '';
    return tag.charAt(0).toUpperCase() + tag.slice(1);
  }

  /**
   * Gender pills for fclo_gender / path tags must be injected in JS —
   * Shopify section AJAX often omits custom query params from Liquid.
   */
  function syncActiveGenderPills() {
    var holder = document.querySelector('[data-active-filters]');
    if (!holder) return;

    var wrapper = holder.closest('.collection__active__filters__wrapper');
    var genders = getActiveGendersFromLocation();
    var basePath = getCollectionBase() || '/collections/all';
    var sortBy = new URL(window.location.href).searchParams.get('sort_by') || '';
    var clearHref = basePath + (sortBy ? '?sort_by=' + encodeURIComponent(sortBy) : '');
    var root = document.querySelector('[data-clear-filters-label]');
    var existingClear = holder.querySelector('.active__filters__clear');
    var clearLabel =
      (root && root.getAttribute('data-clear-filters-label')) ||
      (existingClear && existingClear.textContent.trim()) ||
      'Clear filters';

    holder.querySelectorAll('[data-fclo-remove-path-gender]').forEach(function (el) {
      el.remove();
    });

    function genderAlreadyListed(tag) {
      var links = holder.querySelectorAll('.active__filters__remove');
      for (var i = 0; i < links.length; i++) {
        var text = (links[i].textContent || '')
          .toLowerCase()
          .replace(/\s*x\s*$/i, '')
          .trim();
        if (text === tag) return true;
      }
      return false;
    }

    var clearLink = holder.querySelector('.active__filters__clear');
    var anchorNode = clearLink ? clearLink.nextSibling : holder.firstChild;

    genders.forEach(function (tag) {
      if (genderAlreadyListed(tag)) return;

      var link = document.createElement('a');
      link.className = 'active__filters__remove';
      link.href = clearHref;
      link.setAttribute('data-fclo-remove-path-gender', tag);
      link.setAttribute('data-filter-update-url', '');
      link.innerHTML = capitalizeLabel(tag) + ' <span class="filter__x">X</span>';
      holder.insertBefore(link, anchorNode);
    });

    var removalCount = holder.querySelectorAll('.active__filters__remove').length;
    clearLink = holder.querySelector('.active__filters__clear');

    if (removalCount > 1 && !clearLink) {
      clearLink = document.createElement('a');
      clearLink.href = clearHref;
      clearLink.className = 'active__filters__clear';
      clearLink.setAttribute('data-filter-update-url', '');
      clearLink.textContent = clearLabel;
      holder.insertBefore(clearLink, holder.firstChild);
    } else if (removalCount <= 1 && clearLink) {
      clearLink.remove();
    } else if (clearLink) {
      clearLink.href = clearHref;
    }

    if (wrapper) {
      wrapper.classList.toggle('is-hidden', removalCount === 0);
    }

    var badgeHost = document.querySelector('[data-active-filters-count]');
    if (badgeHost) {
      badgeHost.innerHTML = removalCount > 0 ? '<div class="badge">' + removalCount + '</div>' : '';
    }
  }

  function syncAllVisualState() {
    syncColorVisualState();
    syncGenderVisualState();
    syncActiveGenderPills();
  }

  function currentGenderSelection() {
    var fromDom = readCheckedGenderFromDom();
    if (fromDom.length) return fromDom;
    return getActiveGendersFromLocation();
  }

  function applyGenderToHref(href, genders) {
    var basePath = getCollectionBase();
    if (!basePath) return href;

    var url = new URL(href, window.location.href);
    if (!(url.pathname === basePath || url.pathname.indexOf(basePath + '/') === 0)) {
      return href;
    }

    url.pathname = basePath;
    stripGenderFromParams(url.searchParams);
    url.searchParams.delete('fclo_gender');
    url.searchParams.delete('fclo_and');

    genders = uniqueTags(genders || []);
    if (genders.length === 1) {
      url.searchParams.append('filter.p.tag', genders[0].toLowerCase());
    } else if (genders.length > 1) {
      url.searchParams.set('fclo_gender', genders.join(','));
      genders.forEach(function (tag) {
        url.searchParams.append('filter.p.tag', tag);
      });
    }

    var query = url.searchParams.toString();
    return normalizeAndUrl(url.pathname + (query ? '?' + query : ''));
  }

  // Remove one gender while keeping color / price / remaining gender
  document.addEventListener(
    'click',
    function (event) {
      var removeGender = event.target.closest('[data-fclo-remove-path-gender]');
      if (!removeGender) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setNavIntent({ preserveColors: true, preserveGender: false });

      var basePath = getCollectionBase();
      if (!basePath) {
        triggerFilterUrl(removeGender.getAttribute('href'));
        return;
      }

      var removed = (removeGender.getAttribute('data-fclo-remove-path-gender') || '').toLowerCase();
      var remaining = getActiveGendersFromLocation().filter(function (tag) {
        return tag !== removed;
      });

      var url = new URL(window.location.href);
      url.pathname = basePath;
      stripGenderFromParams(url.searchParams);
      url.searchParams.delete('fclo_gender');
      url.searchParams.delete('fclo_and');

      if (remaining.length === 1) {
        url.searchParams.append('filter.p.tag', remaining[0]);
      } else if (remaining.length > 1) {
        url.searchParams.set('fclo_gender', remaining.join(','));
        remaining.forEach(function (tag) {
          url.searchParams.append('filter.p.tag', tag);
        });
      }

      var query = url.searchParams.toString();
      triggerFilterUrl(url.pathname + (query ? '?' + query : ''));
    },
    true
  );

  // Removing or clearing an active filter chip must not re-apply what was removed
  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('.active__filters__clear')) {
        setNavIntent({ preserveColors: false, preserveGender: false });
        return;
      }

      if (event.target.closest('.active__filters__remove')) {
        setNavIntent({ preserveColors: false, preserveGender: true });
      }
    },
    true
  );

  // Keep selected gender on the path when Shopify filter links would drop it
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('[data-filter-update-url]');
      if (!link) return;
      if (link.hasAttribute('data-fclo-remove-path-gender')) return;
      if (link.hasAttribute('data-fclo-final')) return;
      if (link.classList.contains('active__filters__clear')) return;
      if (!shouldPreserveGender()) return;

      var genders = currentGenderSelection();
      if (!genders.length) return;

      var nextHref = applyGenderToHref(link.getAttribute('href') || '', genders);
      if (nextHref) link.setAttribute('href', nextHref);
    },
    true
  );

  // Color virtual options (Rainbow / Neutrals / missing family tags)
  document.addEventListener(
    'click',
    function (event) {
      var root = getColorRoot();
      if (!root || !root.contains(event.target)) return;

      var virtualRainbow = event.target.closest('[data-color-virtual="rainbow"]');
      var virtualNeutral = event.target.closest('[data-color-virtual="neutral"]');
      var virtualTag = event.target.closest('[data-color-virtual-tag]');

      if (!virtualRainbow && !virtualNeutral && !virtualTag) return;

      event.preventDefault();
      event.stopPropagation();

      if (virtualRainbow) {
        setNavIntent({ preserveColors: false });
        triggerFilterUrl(buildColorUrl([]));
        return;
      }

      if (virtualNeutral) {
        setNavIntent({ preserveColors: true });
        triggerFilterUrl(buildColorUrl(getNeutralTags(root)));
        return;
      }

      setNavIntent({ preserveColors: true });
      triggerFilterUrl(buildColorUrl([virtualTag.getAttribute('data-color-virtual-tag')]));
    },
    true
  );

  // Color family checkbox → keep gender path, replace color tags
  document.addEventListener(
    'input',
    function (event) {
      var root = getColorRoot();
      if (!root || !event.target.matches('[data-color-family-input]')) return;
      if (!event.target.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setNavIntent({ preserveColors: true });
      triggerFilterUrl(buildColorUrl([event.target.value]));
    },
    true
  );

  // Gender checkbox → put gender on path so color filter.p.tag ANDs with it
  document.addEventListener(
    'input',
    function (event) {
      if (!event.target.matches('[data-tag-filter-group="gender"] input[type="checkbox"]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      // Let the checkbox toggle apply, then read all gender boxes
      var genders = readCheckedGenderFromDom();
      triggerFilterUrl(buildUrlFromFormWithGender(genders));
    },
    true
  );

  // Safety net: rewrite any history URL that still ORs gender+color in query
  var pushState = window.history.pushState.bind(window.history);
  var replaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = function (state, title, url) {
    if (url != null && url !== '') {
      url = normalizeAndUrl(mergePreservedColorTags(String(url)));
    }
    navIntent = null;
    return pushState(state, title, url);
  };

  window.history.replaceState = function (state, title, url) {
    if (url != null && url !== '') {
      url = normalizeAndUrl(mergePreservedColorTags(String(url)));
    }
    navIntent = null;
    return replaceState(state, title, url);
  };

  // Fix legacy OR urls / old fclo_and bookmarks
  function migrateLegacyOrUrl() {
    var basePath = getCollectionBase();
    if (!basePath) return;

    var current = window.location.pathname + window.location.search;
    var normalized = normalizeAndUrl(current);
    if (normalized === current) return;

    var params = new URLSearchParams(window.location.search);
    var tags = params.getAll('filter.p.tag');
    var hasGender = tags.some(isGenderTag) || !!params.get('fclo_gender');
    var hasColor = tags.some(isColorTag);
    var pathHasGender = extractPathTags(window.location.pathname, basePath).some(isGenderTag);
    var hasLegacyAnd = params.get('fclo_and') === '1';

    if (hasLegacyAnd || (hasGender && hasColor && !pathHasGender && tags.filter(isGenderTag).length > 1)) {
      replaceState(null, '', normalized);
      triggerFilterUrl(normalized);
    } else if (hasGender && hasColor && !pathHasGender && tags.filter(isGenderTag).length === 1) {
      replaceState(null, '', normalized);
      triggerFilterUrl(normalized);
    }
  }

  syncAllVisualState();
  migrateLegacyOrUrl();

  document.addEventListener('shopify:section:load', syncAllVisualState);
  window.addEventListener('popstate', syncAllVisualState);

  var sidebar = document.querySelector('[data-collection-sidebar]');
  if (sidebar && 'MutationObserver' in window) {
    var syncTimer;
    new MutationObserver(function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncAllVisualState, 50);
    }).observe(sidebar, { childList: true, subtree: true });
  }

  var activeFiltersHolder = document.querySelector('[data-active-filters]');
  if (activeFiltersHolder && 'MutationObserver' in window) {
    var pillsTimer;
    new MutationObserver(function () {
      clearTimeout(pillsTimer);
      pillsTimer = setTimeout(function () {
        // Avoid loops: only re-sync gender pills if URL genders are missing from DOM
        var genders = getActiveGendersFromLocation();
        var shown = activeFiltersHolder.querySelectorAll('[data-fclo-remove-path-gender]').length;
        if (genders.length !== shown) {
          syncActiveGenderPills();
        }
      }, 30);
    }).observe(activeFiltersHolder, { childList: true, subtree: true });
  }
})();
